import { render, staticRenderFns } from "./user-base.vue?vue&type=template&id=1fcd653c&scoped=true&"
import script from "./user-base.vue?vue&type=script&lang=js&"
export * from "./user-base.vue?vue&type=script&lang=js&"
import style0 from "./user-base.vue?vue&type=style&index=0&id=1fcd653c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcd653c",
  null
  
)

export default component.exports